import {createBrowserHistory} from 'history';

// eslint-disable-next-line
const apiFromUrl = window.location.pathname.replace(/^\/([^\/]*).*$/, '$1');
let environment = process.env.NODE_ENV === 'production' ? `/${apiFromUrl}/` : `/${apiFromUrl}/`;

export default createBrowserHistory({basename: environment ? environment : ''})